import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { Button } from '../../components';
import { GLOBAL_ICONS } from '../../util/vars';

const CongratulateButton = ({ ...other }: Record<string, unknown>): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button isOutline color={'positive'} icon={GLOBAL_ICONS.message} inlineText {...other}>
      {translate('components.BUTTONS.CONGRATULATE')}
    </Button>
  );
};

CongratulateButton.displayName = 'CongratulateButton';

export default CongratulateButton;
